import { SupportedLanguageCode } from '@spotify-internal/pillow-talk';

import { Vertical } from 'utils/vertical';

const toLowerCase = (locales: string[]) => locales.map(l => l.toLowerCase());

type SupportedMessagingLocales = Record<Vertical, string[]>;

export const SUPPORTED_MESSAGING_LOCALES: SupportedMessagingLocales = {
  [Vertical.ARTISTS]: toLowerCase(['en-US', 'es-LA', 'es-ES', 'fr-CA', 'fr-FR', 'pt-BR'] as SupportedLanguageCode[]),
  [Vertical.CONSUMER]: toLowerCase([
    'ar',
    'de-DE',
    'en-US',
    'es-ES',
    'es-LA',
    'fr-CA',
    'fr-FR',
    'hi-IN',
    'id-ID',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'ru-RU',
    'sv-SE',
    'th-TH',
    'tr-TR',
    'vi-VN',
    'zh-TW',
  ]),
  [Vertical.PODCASTERS]: toLowerCase(['en-US'] as SupportedLanguageCode[]),
  [Vertical.FINDAWAY]: toLowerCase(['en-US'] as SupportedLanguageCode[]),
};
